import { useAuthStore } from '@school-manage/context/useAuthStore';
import { LoginSearchSchema } from '@school-manage/schema/search.schema';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { Login } from './-components/Login';
import { useLogin } from './-logic/useLogin';
import { LoginContext } from './-logic/useLoginContext';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (useAuthStore.getState().authData) {
      throw redirect({
        replace: true,
        to: '/home',
      });
    }
  },
  component: LoginPage,
  errorComponent: undefined, // Fallback to RootError
  validateSearch: zodValidator(LoginSearchSchema),
});

function LoginPage() {
  return (
    <LoginContext.Provider value={useLogin()}>
      <Login />
    </LoginContext.Provider>
  );
}
